import { render, staticRenderFns } from "./RunMailing.vue?vue&type=template&id=4c06034c"
import script from "./RunMailing.vue?vue&type=script&lang=js"
export * from "./RunMailing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports